import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappApiForSaasContent from './WhatsappApiForSaasContent';

const WhatsappApiForSaas = () => (
  <>
    <Helmet>
      <title>WhatsApp API for SaaS Platforms | HAWKTRION</title>
      <meta name="description" content="Add WhatsApp messaging, templates, automation, and webhooks to your SaaS product with HAWKTRION. Connect customer communication to your platform workflows." />
      <meta name="keywords" content="WhatsApp API for SaaS, SaaS WhatsApp integration, WhatsApp messaging API for software" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api-for-saas/" />
      <meta property="og:title" content="WhatsApp API for SaaS Platforms | HAWKTRION" />
      <meta property="og:description" content="Add WhatsApp messaging, templates, automation, and webhooks to your SaaS product with HAWKTRION. Connect customer communication to your platform workflows." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api-for-saas/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API for SaaS Platforms | HAWKTRION" />
      <meta name="twitter:description" content="Add WhatsApp messaging, templates, automation, and webhooks to your SaaS product with HAWKTRION. Connect customer communication to your platform workflows." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="Add WhatsApp Messaging to Your SaaS Platform" hideCta>
      <WhatsappApiForSaasContent />
    </SeoLandingPage>
  </>
);

export default WhatsappApiForSaas;